import React, { useEffect, useState } from 'react';
import { getRecipeById } from '../services/recipes';
import RecipeDetailComponent from '../components/RecipeDetail';
import { useParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import {Box} from "@mui/material";

function RecipeDetail() {
  const { id } = useParams();
  const [recipe, setRecipe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchRecipe = async () => {
      try {
        setLoading(true);
        const data = await getRecipeById(id);
        setRecipe(data);
      } catch (err) {
        console.error('Error fetching recipe:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchRecipe();
  }, [id]);


  if (loading) {
    return (
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
    );
  }

  if (error || !recipe) {
    return (
        <Typography variant="h5" color="error" align="center" sx={{ mt: 4 }}>
          No se pudo cargar la receta o los ingredientes.
        </Typography>
    );
  }

  return <RecipeDetailComponent recipe={recipe} />;
}

export default RecipeDetail;